"use client";
import { Logger } from "cy-logging";
import { createClientDatadogLogger } from "cy-datadog/client";

export function createLoggerClient(name?: string): Logger {
  name = name || "tv-client-website";
  const ddLogger = createClientDatadogLogger(name);
  return ddLogger;
}
